// extracted by mini-css-extract-plugin
export default {"main":"Tfa-z"};